export default (theme) => ({
    dialogActions: {
        padding: theme.spacing(2),
    },
    actionButton: {
        width: "100%",
    },
});
